import { Navigate } from "react-router-dom";

// Legacy route — the Graph now lives in the Career carousel on the landing page.
export function Graph() {
  return <Navigate to="/?cview=graph" replace />;
}
